export default __webpack_public_path__ + "static/media/craon17.f70286af.jpg";